const embedCalendarElem = document.querySelector('#acuity-iframe');

class Analytics {
  constructor(embedCalendarElem) {
    this.embedCalendarElem = embedCalendarElem;
    this.appointmentPathname = window.location.pathname;
    this.startTracking = this.startTracking.bind(this);
  }

  initAnalytics() {
    this.googleAnalyticsIsLoaded()
      .then(() => {
        if (this.embedCalendarElem) {
          this.observeAcuityCalendar();
        }

        if (this.appointmentPathname === '/pages/cita-agendada-nueva') {
          this.triggerAppointmentEvent();
        }
      })
      .catch(console.error);
  }

  observeAcuityCalendar() {
    if (!this.embedCalendarElem) return;
    window.addEventListener('blur', this.startTracking);
  }

  startTracking() {
    if (document.activeElement == this.embedCalendarElem) {
      const URLParams = window.location.search;
      const analyticsOptions = this.getCampaignParams(URLParams);

      this.saveAnalyticsOptions(analyticsOptions);
      this.triggerViewEvent(analyticsOptions);
      window.removeEventListener('blur', this.startTracking);
    }
  }

  triggerAppointmentEvent() {
    const clientId = this.getClientId();
    const analyticsOptions = JSON.parse(sessionStorage.getItem(clientId));
    const URLParams = window.location.search;
    const appointmentType = this.getappointmentType(URLParams);

    if (
      analyticsOptions !== null &&
      analyticsOptions !== '' &&
      performance.getEntriesByType('navigation')[0].type === 'navigate'
    ) {
      // Google Analytics
      ga('send', 'event', {
        eventCategory: 'Appointment',
        eventAction: 'Appointment Schedule (nueva)',
        ...(appointmentType !== null && {eventLabel: appointmentType}),
        ...analyticsOptions,
      });

      // Pinterest
      pintrk('track', 'lead', {
        lead_type: 'Appointment Schedule',
      });
    }
  }

  triggerViewEvent(options) {
    // Google Analytics¡
    ga('send', 'event', {
      eventCategory: 'Appointment',
      eventAction: 'Open Agenda (nueva)',
      ...options,
    });

    // Pinterest
    pintrk('track', 'lead', {
      lead_type: 'Open Agenda',
    });
  }

  saveAnalyticsOptions(options) {
    const clientId = this.getClientId();
    sessionStorage.setItem(clientId, JSON.stringify(options));
  }

  getappointmentType(URL) {
    const params = new URLSearchParams(URL);
    return params.has('appointmentType')
      ? decodeURI(params.get('appointmentType'))
      : null;
  }

  getCampaignParams(URL) {
    const params = new URLSearchParams(URL);

    return {
      ...(document.referrer && {referrer: document.referrer}),
      ...(params.has('utm_campaign') && {
        campaignName: params.get('utm_campaign'),
      }),
      ...(params.has('utm_source') && {
        campaignSource: params.get('utm_source'),
      }),
      ...(params.has('utm_medium') && {
        campaignMedium: params.get('utm_medium'),
      }),
    };
  }

  getClientId() {
    let clientId = '';

    ga((tracker) => {
      clientId = tracker.get('clientId');
    });

    return clientId;
  }

  googleAnalyticsIsLoaded() {
    return new Promise((resolve, reject) => {
      const timeStart = Date.now();
      const timeOut = 5000;

      const isLoaded = () => {
        if (Date.now() - timeStart > timeOut) {
          reject('Timeout');
          return;
        }

        if (window.ga && ga.create) {
          resolve(ga);
          return;
        } else {
          setTimeout(isLoaded, 500);
        }
      };

      isLoaded();
    });
  }
}

const analytics = new Analytics(embedCalendarElem);
analytics.initAnalytics();
